import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, InputAdornment, Stack, TextField } from '@mui/material'
import React, { useMemo, useState } from 'react'
import PaperDraggable from '../../../../../../../components/PaperDraggable'
import UploadFileListItem from '../../../../../../../components/UploadFileListItem'
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useMutation, useQueryClient } from 'react-query';
import axiosClient from '../../../../../../../lib/axios';
import { enqueueSnackbar } from 'notistack';


export default function DialogAdicionarCertificado({
    open,
    agronomo_id,
    handleClose
}: DialogAdicionarCertificadoProps) {

    const queryClient = useQueryClient();

    const [certificados, setCertificados] = useState<File | null>(null)
    const [senha, setSenha] = useState<string>("")
    const [mostraSenha, setMostrarSenha] = useState(false)

    const disabletBtnAdicionar = useMemo(() => {
        return !certificados
    }, [certificados])

    //querys e mutations
    const { mutate: addCertificado, isLoading: isLoadingAdd } = useMutation({
        mutationKey: 'adicionar-certificado',
        mutationFn: (inputs: any) => axiosClient.post("/receituario-agronomico/adicionar-certificado", { ...inputs }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }),
        onError: (error) => {
            console.error(error)
            enqueueSnackbar('Erro ao adicionar certificado!', { variant: 'error' });
        },
        onSuccess: () => {
            queryClient.invalidateQueries(`detalhar-agronomo/${agronomo_id}`)
            enqueueSnackbar(`Certificado salvo com sucesso!`, { variant: 'success' });
            handleClose()
        }
    })
    //

    //Functions
    const handleSubmit = (certificado: File, senha: string) => {
        const params = {
            agronomo_id: agronomo_id,
            certificado,
            senha: senha.trim() === "" ? null : senha,
        };
        addCertificado(params)
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                Adicionar certificado
            </DialogTitle>
            <DialogContent>
                <Stack direction={'column'} spacing={2}>
                    <UploadFileListItem
                        label={"Certificado"}
                        value={certificados}
                        onChangeValue={(arquivo) => setCertificados(arquivo)}
                        filesExtension={".pfx,.p12,.pem,.cer,.crt,.key"}
                    />
                    <TextField
                        margin="normal"
                        fullWidth
                        label="Senha"
                        type={mostraSenha ? "text" : "password"}
                        id="senha"
                        autoComplete="current-senha"
                        value={senha}
                        onChange={(e) => setSenha(e.target.value)}
                        slotProps={{
                            input: {
                                endAdornment:
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() => setMostrarSenha(prevState => !prevState)}
                                        >
                                            {mostraSenha ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                            }
                        }}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleClose}
                    disabled={isLoadingAdd}
                >
                    Fechar
                </Button>
                <Button
                    variant='contained'
                    onClick={() => { handleSubmit(certificados as File, senha) }}
                    disabled={disabletBtnAdicionar || isLoadingAdd}
                >
                    {
                        isLoadingAdd && <CircularProgress size={20} sx={{ mr: 1 }} />
                    }
                    Adicionar
                </Button>
            </DialogActions>

        </Dialog>
    )
}

interface DialogAdicionarCertificadoProps {
    agronomo_id: number,
    open: boolean,
    handleClose: () => void
}